import isArray from 'lodash/isArray';

import { RendererType } from '../../../../constants';
import { Graph, Command } from '../../../../types';

export const shouldTriggerShortcut = (graph: Graph, target: HTMLElement | null) => {
  if (!target) return false;

  const canvasElement = graph.get('canvas').get('el');

  if (target === canvasElement) return true;

  const renderer: RendererType = graph.get('renderer');

  if (renderer !== RendererType.Svg) return false;
  if (target.nodeName === 'svg') return true;

  let { parentNode } = target;

  while (parentNode && parentNode.nodeName !== 'BODY') {
    if (parentNode.nodeName === 'svg') {
      return true;
    } else {
      parentNode = parentNode.parentNode;
    }
  }

  return false;
};

export const isShortcutTriggered = (
  command: Command,
  e: Partial<KeyboardEvent> & { [key: string]: any },
) =>
  command.shortcuts.some((shortcut: string | string[]) =>
    !isArray(shortcut)
      ? shortcut === e.key
      : shortcut.every((item: string, index) =>
          index === shortcut.length - 1 ? item === e.key : e[item as string],
        ),
  );
